/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SkeeloPersonBenefitReportDTO {
  active?: boolean;
  dateCreated?: Date;
  dateDeactivated?: Date;
  document?: string;
  editionId?: number;
  email?: string;
  personId?: number;
  planCode?: string;
  skeeloSubscriptionHistoryId?: number;
  subscriberBillingId?: number;
  subscriptionName?: string;
}
